import TemplateView from '../../../../TemplateView'
import messageResource from '../../../../messageResource'
import {MONTH_LICENSES_DURATION, YEAR_LICENSES_DURATION} from '../../constants'
import {Product} from 'constants'
import {DateFormat} from '../../../../date_format'

export default class LicenseCard extends TemplateView {
    constructor({
        active,
        trial,
        expired,
        startDate,
        expirationDate,
        daysToExpiration,
        issueDate,
        unlimited,
        allowedUsersCount,
        free,
        currentUsersCount,
        formattedName,
        licensesMonthCount,
        product,
        gracePeriod,
        endDateWithGracePeriod,
        licenseId,
        licenseExpires,
        onAddUsersButtonClick = () => {},
    }) {
        super()

        this.params = {
            active,
            trial,
            startDate,
            expired,
            expirationDate,
            daysToExpiration,
            issueDate,
            unlimited,
            allowedUsersCount,
            free,
            currentUsersCount,
            formattedName,
            licensesMonthCount,
            product,
            gracePeriod,
            endDateWithGracePeriod,
            licenseId,
            licenseExpires,
        }

        this.actions = {
            onAddUsersButtonClick
        }

        this.dateFormat = new DateFormat(window.SystemSettings.dateFormat)
    }

    templateHtml() {
        return '<div class="licenseCard">' +
               '    <div class="headerCard">' +
               '        <div class="img"/>' +
               '        <div class="licensesTitle">' +
               '            <div class="text"/>' +
               '            <div class="daysLeft">' +
               '                <div class="label"/>' +
               '            </div>' +
               '        </div>' +
               '        <div class="addUsers">' +
               '            <div class="addUsersButton"><%=addButtonMessage%></div>' +
               '            <div class="addUsersArrow"/>' +
               '        </div>' +
               '    </div>' +
               '    <div class="licensesInfo">' +
               '        <div class="usersSection">' +
               '            <div class="usersLicenses"/>' +
               '            <div class="currentUserCount"/>' +
               '        </div>' +
               '        <div class="warningSection">' +
               '            <div class="warning"/>' +
               '        </div>' +
               '        <div class="dateSection">' +
               '            <div class="dateDuration"/>' +
               '            <div class="gracePeriod"/>' +
               '        </div>' +
               '    </div>' +
               '    <div class="footerCard">' +
               '        <div class="purchasedInfo"/>' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            addButtonMessage: 'licenses.add_users',
        }
    }

    afterRender() {
        this.$licenseTitleText = this.find('.licensesTitle .text')
        this.$licenseTitleText.text(this._getLicensesTitle())
        this.$licenseTitleText.toggleClass('expired', this.params.expired)
        this.$daysLeft = this.find('.daysLeft')
        this.$daysLeft.find('.label').text(this._getDaysLeftText())
        this.find('.usersLicenses').text(this._getUsersLicenses())

        this.find('.currentUserCount').text(messageResource.getMessage('licenses.used_user', [this.params.currentUsersCount]))

        this.$dateDuration = this.find('.dateDuration')
        this.$dateDuration.html(this._getLicensesDateDuration())
        this.find('.gracePeriod').text(this._getGracePeriodText())
        this.find('.dateSection').toggle(!this.params.free)

        const needToDisableUsers = this.params.allowedUsersCount < this.params.currentUsersCount && !this.params.unlimited
        this.$warning = this.find('.warning')
        this.$warning.text(this._getWarningText())
        this.find('.warningSection').toggle(needToDisableUsers && !this.params.expired)

        this.find('.purchasedInfo').text(this._getIssueText())

        const isAddUserButtonVisible = !this.params.trial && !this.params.free && !this.params.unlimited && !this.params.expired
        this.$addUsers = this.find('.addUsers')

        this.$addUsers.toggle(isAddUserButtonVisible)
        if (isAddUserButtonVisible) {
            this.$addUsers.click(this.actions.onAddUsersButtonClick)
            this.find('.addUsersArrow').toggle(needToDisableUsers)
        }

        this.find('.footerCard').toggle(!this.params.trial)

        this.$productLogo = this.find('.img')
        this.$productLogo.toggleClass('at', this.params.product === Product.actiTIME)
        this.$productLogo.toggleClass('ap', this.params.product === Product.actiPLANS)

        this.$daysLeft.toggleClass('notStarted', !this.params.expired && !this.params.active)
        this.$daysLeft.toggleClass('expired', this.params.expired || (this.params.active && this.params.licenseExpires))
        this.$daysLeft.toggleClass('active', this.params.active && !needToDisableUsers)
        this.$daysLeft.toggleClass('violated', this.params.active && needToDisableUsers)
        if (this.params.active && this.params.free) {
            this.$daysLeft.hide()
        }

        this.getEl().toggleClass('active', this.params.active)
        this.getEl().toggleClass('trialCard', this.params.trial)
        this.getEl().toggleClass('withoutDate', this.params.free && !needToDisableUsers)
    }

    _getLicensesTitle() {
        if (this.params.active) {
            if (this.params.trial) {
                return messageResource.getMessage('licenses.active_trial')
            } else if (this.params.allowedUsersCount < this.params.currentUsersCount && !this.params.unlimited) {
                return messageResource.getMessage(this.params.free ? 'licenses.free_violated' : 'licenses.violated')
            } else if (this.params.free) {
                return messageResource.getMessage('licenses.active_free')
            } else {
                return messageResource.getMessage('licenses.active')
            }

        } else if (!this.params.expired) {
            let message = messageResource.getMessage('licenses.next', [this.dateFormat.formatDate(this.params.startDate)])

            if (this.params.free) {
                message += " " + messageResource.getMessage('licenses.free_version_hooks')
            }

            return message
        } else {
            let message = messageResource.getMessage('licenses.expired')

            if (this.params.free) {
                message += " " + messageResource.getMessage('licenses.free_version_hooks')
            }

            if (this.params.trial) {
                message += " " + messageResource.getMessage('licenses.trial_version_hooks')
            }

            return message
        }
    }

    _getDaysLeftText() {
        let now = new Date()

        if (this.params.startDate > now && !this.params.active) {
            return messageResource.getMessage('licenses.not_started')
        } else if (this.params.expired) {
            return messageResource.getMessage('licenses.expired_label')
        } else if (this.params.allowedUsersCount < this.params.currentUsersCount && !this.params.unlimited) {
            return messageResource.getMessage('licenses.violated_label')
        } else {
            return messageResource.getMessage('licenses.days_left', [this.params.daysToExpiration])
        }
    }

    _getUsersLicenses() {
        if (this.params.unlimited) {
            return messageResource.getMessage('licenses.unlimited_users')
        }

        return messageResource.getMessage('licenses.users_count', [this.params.allowedUsersCount])
    }

    _getIssueText() {
        if (this.params.free) {
            return messageResource.getMessage('licenses.issued_footer_licenses_card',
                [this.dateFormat.formatDate(this.params.issueDate), this.params.formattedName])
        }

        return messageResource.getMessage('licenses.purchased', [this.params.formattedName, this.dateFormat.formatDate(this.params.issueDate)])
    }

    _getWarningText() {
        if (this.params.allowedUsersCount < this.params.currentUsersCount && !this.params.unlimited && !this.params.expired) {
            let usersForDisable = this.params.currentUsersCount - this.params.allowedUsersCount

            if (this.params.active && !this.params.free) {
                return messageResource.getMessage('licenses.disable_users_active_commercial', [usersForDisable, this.params.currentUsersCount])
            } else if (this.params.active && this.params.free) {
                return messageResource.getMessage('licenses.disabled_users_active', [usersForDisable, this.params.currentUsersCount])
            } else if (this.params.free) {
                return messageResource.getMessage('licenses.disabled_users_next',
                    [usersForDisable, this.params.currentUsersCount, this.dateFormat.formatDate(this.params.startDate)])
            } else {
                return messageResource.getMessage('licenses.disable_users_next_commercial',
                    [usersForDisable, this.params.currentUsersCount, this.dateFormat.formatDate(this.params.startDate)])
            }
        }
    }

    _getLicensesDateDuration() {
        if (this.params.trial) {
            return messageResource.getMessage('licenses.trial_duration',
                [this.dateFormat.formatDate(this.params.startDate), this.dateFormat.formatDate(this.params.expirationDate)])
        }

        if (this.params.licensesMonthCount === MONTH_LICENSES_DURATION) {
            return messageResource.getMessage('licenses.month_duration',
                [this.dateFormat.formatDate(this.params.startDate), this.dateFormat.formatDate(this.params.expirationDate)])
        } else if (this.params.licensesMonthCount === YEAR_LICENSES_DURATION) {
            return messageResource.getMessage('licenses.year_duration',
                [this.dateFormat.formatDate(this.params.startDate), this.dateFormat.formatDate(this.params.expirationDate)])
        } else {
            return messageResource.getMessage('licenses.non_standard_duration',
                [this.params.licensesMonthCount, this.dateFormat.formatDate(this.params.startDate), this.dateFormat.formatDate(this.params.expirationDate)])
        }
    }

    _getGracePeriodText() {
        if (this.params.gracePeriod > 0) {
            return messageResource.getMessage('licenses.card.grace_period_text',
                [this.params.gracePeriod, this.dateFormat.formatDate(this.params.endDateWithGracePeriod)])
        }

        return ''
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/licenseList/LicenseCard.js